import PanelLayout from "../../layout/PanelLayout";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import { setIsToggle } from "../../redux/reducers/assetReducer";
import Sidebar from "../../components/pages/Account Setting/Sidebar";
import MyAccount from "../../components/pages/Account Setting/MyAccount";
import EditProfile from "../../components/pages/Account Setting/EditProfile";
import Notification from "../../components/pages/Account Setting/Notification";
import Subscription from "../../components/pages/Account Setting/Subscription";
import DeleteAccount from "../../components/pages/Account Setting/DeleteAccount";
import ChangePassword from "../../components/pages/Account Setting/ChangePassword";
import Loader from "../../components/loader";

const AccountSetting = () => {
  const { type } = useParams();
  const dispatch = useDispatch();
    const { isLoading } = useSelector((state) => state.authReducer);
  
  const { isToggle } = useSelector((state) => state.assetReducer);
  const tabComponents = {
    notification: <Notification />,
    "my-account": <MyAccount />,
    "edit-profile": <EditProfile />,
    "change-password": <ChangePassword />,
    subscription: <Subscription />,
    "delete-account": <DeleteAccount />,
  };

  const validTabs = [
    "notification",
    "my-account",
    "edit-profile",
    "change-password",
    "subscription",
    "delete-account",
  ];

  if (!validTabs.includes(type)) {
    console.log({ type });
    return <Navigate to="/account-setting/notification" />;
  }



  return (
    <PanelLayout>
      <div class="ct_py_80">
        <div class="container">
          <div class="row">
            <div class="col-lg-4">
              {/* Mobile Sidebar Toggle Button */}
              <button
                class="btn d-lg-none mb-3"
                id="profileMenuBtn"
                onClick={() => {
                  dispatch(setIsToggle(true));
                }}
              >
                <i class="fa-solid fa-gear"></i> Setting
              </button>

              {/* Sidebar */}
              <Sidebar type={type} />
            </div>
            <div class="col-lg-8 ">
              <div class="ct_right_main_box py-5">{tabComponents[type]}</div>
            </div>
          </div>
        </div>
      </div>
    </PanelLayout>
  );
};

export default AccountSetting;
